// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Buttons (primary, default, danger).
 */

/* Primary button (green) */
.btn-gh-primary {
  background-color: var(--gh-btn-primary-bg);
  border: 1px solid rgba(31, 35, 40, 0.15);
  color: #ffffff;
  font-weight: 500;
}

.btn-gh-primary:hover {
  background-color: var(--gh-btn-primary-hover);
  color: #ffffff;
}

.btn-gh-primary:disabled {
  background-color: var(--gh-btn-primary-bg);
  color: #ffffff;
  opacity: 0.6;
}

/* Default button (white) */
.btn-gh {
  background-color: var(--gh-canvas-subtle);
  border: 1px solid var(--gh-border-default);
  color: var(--gh-fg-default);
  font-weight: 500;
}

.btn-gh:hover {
  background-color: #f3f4f6;
  border-color: var(--gh-fg-muted);
  color: var(--gh-fg-default);
}

/* Danger button */
.btn-gh-danger {
  background-color: var(--gh-canvas-subtle);
  border: 1px solid var(--gh-border-default);
  color: var(--gh-danger-fg);
  font-weight: 500;
}

.btn-gh-danger:hover {
  background-color: var(--gh-danger-fg);
  border-color: var(--gh-danger-fg);
  color: #ffffff;
}

.btn-gh-danger:disabled {
  background-color: var(--gh-canvas-subtle);
  border-color: var(--gh-border-default);
  color: var(--gh-danger-fg);
  opacity: 0.35;
}
`, "",{"version":3,"sources":["webpack://./src/styles/buttons.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF,2BAA2B;AAC3B;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;EACtC,0BAA0B;EAC1B,aAAa;AACf","sourcesContent":["/*\n * Buttons (primary, default, danger).\n */\n\n/* Primary button (green) */\n.btn-gh-primary {\n  background-color: var(--gh-btn-primary-bg);\n  border: 1px solid rgba(31, 35, 40, 0.15);\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.btn-gh-primary:hover {\n  background-color: var(--gh-btn-primary-hover);\n  color: #ffffff;\n}\n\n.btn-gh-primary:disabled {\n  background-color: var(--gh-btn-primary-bg);\n  color: #ffffff;\n  opacity: 0.6;\n}\n\n/* Default button (white) */\n.btn-gh {\n  background-color: var(--gh-canvas-subtle);\n  border: 1px solid var(--gh-border-default);\n  color: var(--gh-fg-default);\n  font-weight: 500;\n}\n\n.btn-gh:hover {\n  background-color: #f3f4f6;\n  border-color: var(--gh-fg-muted);\n  color: var(--gh-fg-default);\n}\n\n/* Danger button */\n.btn-gh-danger {\n  background-color: var(--gh-canvas-subtle);\n  border: 1px solid var(--gh-border-default);\n  color: var(--gh-danger-fg);\n  font-weight: 500;\n}\n\n.btn-gh-danger:hover {\n  background-color: var(--gh-danger-fg);\n  border-color: var(--gh-danger-fg);\n  color: #ffffff;\n}\n\n.btn-gh-danger:disabled {\n  background-color: var(--gh-canvas-subtle);\n  border-color: var(--gh-border-default);\n  color: var(--gh-danger-fg);\n  opacity: 0.35;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
